<svg
	width="24px"
	height="24px"
	viewBox="0 0 24 24"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
>
	<g
		id="icon-action-forward-default"
		stroke="none"
		stroke-width="1"
		fill="none"
		fill-rule="evenodd"
	>
		<path
			d="M20.75,7.74999998 L14,3.32999996 L14,6.99999998 L12.16,6.99999998 C7.65999998,6.99999998 3.99999997,10.66 3.99999997,15.16 L3.99999997,19.25 C3.99999997,19.665 4.33499997,20 4.74999997,20 C5.16499997,20 5.49999997,19.665 5.49999997,19.25 L5.49999997,15.16 C5.49999997,11.485 8.48499999,8.49999999 12.16,8.49999999 L14,8.49999999 L14,12.17 L20.75,7.74999998 Z"
			id="Path"
			fill="currentColor"
		></path>
	</g>
</svg>
